module.exports = __webpack_public_path__ + "static/media/11.eac7ffb7.jpg";